import { render, staticRenderFns } from "./error.vue?vue&type=template&id=187be92f&"
import script from "./error.vue?vue&type=script&lang=js&"
export * from "./error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ErrorPage: require('/home/runner/work/api-docs-frontend/api-docs-frontend/components/ErrorPage/index.vue').default})
